import { useEffect } from "react";

let ctx;
const unlock = () => {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return;
  ctx = ctx || new AC();
  if (ctx.state === "suspended") ctx.resume();
};
["pointerdown", "touchstart", "keydown"].forEach((e) => window.addEventListener(e, unlock, { passive: true }));

const beep = (t, freq, dur) => {
  const o = ctx.createOscillator();
  const g = ctx.createGain();
  o.type = "square";
  o.frequency.setValueAtTime(freq, t);
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(0.9, t + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g).connect(ctx.destination);
  o.start(t);
  o.stop(t + dur + 0.02);
};

export const ringOnce = () => {
  unlock();
  if (!ctx) return;
  const t = ctx.currentTime + 0.02;
  [[0, 988], [0.18, 1319], [0.36, 988], [0.54, 1319]].forEach(([d, f]) => beep(t + d, f, 0.16));
  navigator.vibrate?.([400, 150, 400]);
};

export const useRingtone = (active) => {
  useEffect(() => {
    if (!active) return;
    ringOnce();
    const id = setInterval(ringOnce, 1600);
    return () => { clearInterval(id); navigator.vibrate?.(0); };
  }, [active]);
};

export const alertInBackground = (title, body) => {
  if (document.hidden && "Notification" in window && Notification.permission === "granted") {
    try { new Notification(title, { body, icon: "/icon-192.png", tag: "ks-offer", renotify: true, requireInteraction: true }); } catch { /* ignore */ }
  }
};
